import { Send } from 'lucide-react';
import { Input } from '../ui/input';
import { Button } from '../ui/button';

// The ONE buyer-side message thread. Contact Sales and the confidential
// insurance thread are the same conversation engine (db.request_messages +
// /vehicle/conversation/:id), so they are also the same UI — only the peer
// label, the accent and the footer note differ.
export const BuyerChatThread = ({
    messages = [],
    input = '',
    onInputChange,
    onSend,
    peerLabel,
    empty,
    note,
    prefix = 've-chat',
    accent = 'bg-blue-600 hover:bg-blue-500',
    bubbleMine = 'bg-blue-600 text-white',
    peerTag = 'text-blue-300',
    mineStyle,
    sendStyle,
    tone = {
        wrap: '',
        peerBubble: 'bg-white/10 text-neutral-100',
        emptyText: 'text-neutral-400',
        inputRow: 'border-t border-neutral-800',
        input: 'bg-neutral-800 border-neutral-700',
        note: 'text-neutral-400',
    },
}) => (
    <>
        <div className={`flex-1 min-h-[7rem] max-h-64 overflow-y-auto px-4 py-3 space-y-2.5 ${tone.wrap}`}
            data-testid={`${prefix}-messages`}>
            {messages.length === 0 && (
                <p className={`text-center text-xs py-6 ${tone.emptyText}`} data-testid={`${prefix}-empty`}>{empty}</p>
            )}
            {messages.map((m, i) => (
                <div key={i} className={`flex ${m.sender_role === 'customer' ? 'justify-end' : 'justify-start'}`}>
                    <div className={`max-w-[80%] rounded-2xl px-3.5 py-2 text-sm ${m.sender_role === 'customer' ? bubbleMine : tone.peerBubble}`}
                        style={m.sender_role === 'customer' ? mineStyle : undefined}
                        data-testid={`${prefix}-bubble`}>
                        {m.sender_role !== 'customer' && peerLabel && (
                            <p className={`text-[10px] uppercase tracking-wide mb-0.5 ${peerTag}`}>{peerLabel}</p>
                        )}
                        {m.photo_url && <img src={m.photo_url} alt="" className="rounded-lg mb-1 max-h-40" />}
                        {m.body}
                    </div>
                </div>
            ))}
        </div>
        <div className={`p-3 flex shrink-0 items-center gap-2 ${tone.inputRow}`}>
            <Input value={input} onChange={(e) => onInputChange(e.target.value)}
                onKeyDown={(e) => e.key === 'Enter' && onSend()}
                placeholder={note?.placeholder} className={tone.input}
                data-testid={`${prefix}-input`} />
            <Button size="icon" onClick={onSend} data-testid={`${prefix}-send`} style={sendStyle}
                className={`${accent} text-white flex-shrink-0 transition-transform active:scale-95 motion-reduce:transition-none motion-reduce:active:scale-100`}>
                <Send className="w-4 h-4" />
            </Button>
        </div>
        {note?.text ? (
            <p className={`px-4 pb-3 shrink-0 text-[11px] leading-relaxed ${tone.note}`} data-testid={`${prefix}-footer-note`}>
                {note.text}
            </p>
        ) : null}
    </>
);

export default BuyerChatThread;
